import Vue from "vue";
import Vuex from "vuex";
import VueCookie from "vue-cookie";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import titleMixin from "./utils/title";

// Firebase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.functions();
const storage = firebase.storage();
export { firebase, db, auth, functions, storage };

import { firestorePlugin } from "vuefire";
Vue.use(firestorePlugin);

// Fontawsome
import { dom } from "@fortawesome/fontawesome-svg-core";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
dom.watch(); // This will kick of the initial replacement of i to svg tags and configure a MutationObserver
library.add(fas, far, fab);
Vue.component("fa-icon", FontAwesomeIcon);

// Buefy
import Buefy from "buefy";
Vue.use(Buefy, {
  defaultIconPack: "fas",
});

// Tippy
import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy, {});
Vue.component("tippy", TippyComponent);

// import "tippy.js/themes/light-border.css";
import "./assets/css/style.css"
import "./assets/css/custom.css"

// Toasted
import Toasted from "vue-toasted";
Vue.use(Toasted, {
  theme: 'toasted-primary',
  position: 'top-right',
  containerClass: 'is-edge',
  iconPack: 'custom-class',
  icon: 'fas fa-exclamation-circle',
  duration: 5000
})

// Dayjs
import dayjs from "dayjs";
import "dayjs/locale/ja";
import localizedFormat from "dayjs/plugin/localizedFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.locale("ja");
dayjs.extend(localizedFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
Vue.prototype.$date = dayjs;

// JsonCSV
import JsonCSV from "vue-json-csv";
Vue.component("download-csv", JsonCSV);

// Twemoji
import twemoji from "twemoji";
Vue.directive("twemoji", {
  inserted(el) {
    el.innerHTML = twemoji.parse(el.innerHTML);
  },
});

// Plugins
import SetInterval from "@/plugins/SetInterval";
Vue.use(SetInterval);

// Filters
import * as filters from "./filters";
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

//Vee-validator
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { messages } from 'vee-validate/dist/locale/ja.json';
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});
extend('verify_password', {
  getMessage: field => 'パスワードは大文字と小文字の半角英字、数字を組みあわせて8文字以上で入力してください。',
  validate: value => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
    return strongRegex.test(value);
  }
});

Vue.mixin(titleMixin);

// Vue.use(VueRouter)
Vue.use(Vuex);
Vue.use(VueCookie);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
